<template>
  <div class="list">
    <navbar :docsName="docsName" />
    <div class="container-fluid">
      <div class="row">
        <div class="col-2">
          <div class="container-fluid">
            <head-menu-filter
              :col="12"
              class="d-xl-flex"
              :headline="$t('global.filter')"
              :showIcons="false"
            ></head-menu-filter>
            <div class="row mb-2">
              <div class="viewfilter block br-t-l-0 br-t-r-0 w-100-p br-t-l-xl-0 br-t-r-xl-0 mt-minus-10">
                <div class="row">
                  <div class="col-xl-12">
                    <div class="form-group">
                      <input
                        v-model="filterDE"
                        @input="applyFilter"
                        class="form-control input"
                        type="text"
                        placeholder=" "
                      />
                      <label>{{ $t("global.designation") }} - DE</label>
                    </div>
                  </div>
                  <div class="col-xl-12">
                    <div class="form-group">
                      <input
                        v-model="filterEN"
                        @input="applyFilter"
                        class="form-control input"
                        type="text"
                        placeholder=" "
                      />
                      <label>{{ $t("global.designation") }} - EN</label>
                    </div>
                  </div>
                  <div class="col-xl-12">
                    <div class="form-group">
                      <input
                        v-model="filterFR"
                        @input="applyFilter"
                        class="form-control input"
                        type="text"
                        placeholder=" "
                      />
                      <label>{{ $t("global.designation") }} - FR</label>
                    </div>
                  </div>
                  <div class="col-xl-12">
                    <div class="form-group">
                      <input
                        v-model="filterIT"
                        @input="applyFilter"
                        class="form-control input"
                        type="text"
                        placeholder=" "
                      />
                      <label>{{ $t("global.designation") }} - IT</label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-10">
          <div class="container-fluid">
            <head-menu
              :col="12"
              class="d-xl-flex"
              :headline="$t('global.relationstype')"
            ></head-menu>
            <div class="row mb-2">
              <div class="block br-t-l-0 w-100-p br-t-l-xl-0">
                <div class="row mt-2 d-flex justify-content-between">
                  <div class="ml-4 mr-2">
                    <button
                      v-if="berechtigungen.g_einstellungen.create"
                      class="btn btn-success"
                      @click="oeffneModal(null)"
                    >
                      <font-awesome-icon icon="fa-regular fa-plus" />
                      {{ $t("global.new") }}
                    </button>
                  </div>
                  <div class="mr-4">
                    <button
                      v-if="berechtigungen.g_einstellungen.delete"
                      class="btn btn-danger"
                      @click="oeffneLoeschenModal"
                    >
                      <font-awesome-icon class="mr-1" icon="fa-duotone fa-trash" />
                      {{ $t("global.delete") }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div class="row block belegliste">
              <div class="w-100-p">
                <b-table
                  ref="selectableTable"
                  small
                  tbody-tr-class="item"
                  :items="filteredList"
                  :fields="fields"
                  :busy="isBusy"
                  show-empty
                  sort-icon-left
                  fixed
                  selectable
                  select-mode="range"
                  @row-dblclicked="oeffneModal"
                >
                  <template v-slot:head(selected)="header">
                    <b-form-checkbox
                      ref="headerCheckbox"
                      v-model="header.selected"
                      @input="selectAllRows(header)"
                    ></b-form-checkbox>
                  </template>
                  <template v-slot:cell(selected)="row">
                    <b-form-checkbox
                      v-model="row.item.selected"
                      @input="onRowSelected(row)"
                    ></b-form-checkbox>
                  </template>
                  <template v-slot:cell(de)="row">
                    <div>{{ row.item.de && row.item.de.text }}</div>
                    <div class="text-muted font-italic">{{ row.item.de2 && row.item.de2.text }}</div>
                  </template>
                  <template v-slot:cell(en)="row">
                    <div>{{ row.item.en && row.item.en.text }}</div>
                    <div class="text-muted font-italic">{{ row.item.en2 && row.item.en2.text }}</div>
                  </template>
                  <template v-slot:cell(fr)="row">
                    <div>{{ row.item.fr && row.item.fr.text }}</div>
                    <div class="text-muted font-italic">{{ row.item.fr2 && row.item.fr2.text }}</div>
                  </template>
                  <template v-slot:cell(it)="row">
                    <div>{{ row.item.it && row.item.it.text }}</div>
                    <div class="text-muted font-italic">{{ row.item.it2 && row.item.it2.text }}</div>
                  </template>
                  <template #table-busy>
                    <div class="text-center text-primary my-2">
                      <b-spinner class="align-middle"></b-spinner>
                    </div>
                  </template>
                  <template #empty>
                    <div v-if="ladeFehler" class="text-center text-danger my-2">
                      <strong>{{ $t("global.errorwhileloading") }}</strong>
                    </div>
                    <div v-else class="text-center text-primary my-2">
                      <strong>{{ $t("global.nodataavailable") }}</strong>
                    </div>
                  </template>
                </b-table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <loading-overlay v-show="isBusy"></loading-overlay>

    <relationstyp-modal
      id="relationstyp-modal"
      :selectedItem="selectedItem"
      @confirmed="getData"
    />

    <loeschen-modal
      id="relationstyp-loeschen-modal"
      @confirmed="loeschen"
      :selectedIds="selectedIds"
    />
  </div>
</template>

<script>
import AppApi from "@/api/AppApi";
import HeadMenu from "@/components/HeadMenu";
import HeadMenuFilter from "@/components/HeadMenuFilter";
import Navbar from "@/components/Navbar";
import LoeschenModal from "@/components/Modals/LoeschenModal";
import RelationstypModal from "@/components/Modals/RelationstypModal";
import { apiErrorToAlert } from "@/utils/Errorhandler";
import page from "@/mixins/Page";
import store from "@/store";
import { BSpinner } from "bootstrap-vue";

export default {
  name: "RelationstypAuswahlwertePage",
  components: {
    HeadMenu,
    HeadMenuFilter,
    Navbar,
    LoeschenModal,
    RelationstypModal,
    BSpinner,
  },
  mixins: [page],
  store,
  data() {
    return {
      isBusy: false,
      ladeFehler: false,
      list: [],
      filteredList: [],
      filterDE: "",
      filterEN: "",
      filterFR: "",
      filterIT: "",
      selectedItem: null,
      selectedIds: [],
    };
  },
  computed: {
    fields() {
      return [
        { key: "selected", label: "", thStyle: { width: "30px" } },
        { key: "de", label: this.$t("global.designation") + " - DE", thStyle: { width: "24.925%" } },
        { key: "en", label: this.$t("global.designation") + " - EN", thStyle: { width: "24.925%" } },
        { key: "fr", label: this.$t("global.designation") + " - FR", thStyle: { width: "24.925%" } },
        { key: "it", label: this.$t("global.designation") + " - IT", thStyle: { width: "24.925%" } },
      ];
    },
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      this.isBusy = true;
      AppApi.get("auswahlwerte/relationstyp")
        .then((response) => {
          this.list = response.data;
          this.filteredList = response.data;
          this.ladeFehler = false;
        })
        .catch(() => {
          this.ladeFehler = true;
        })
        .finally(() => {
          this.isBusy = false;
        });
    },

    applyFilter() {
      this.filteredList = this.list.filter((item) => {
        const contains = (text, filter) => (text ?? "").toLowerCase().includes(filter.toLowerCase());
        const matchDE = !this.filterDE || contains(item.de?.text, this.filterDE) || contains(item.de2?.text, this.filterDE);
        const matchEN = !this.filterEN || contains(item.en?.text, this.filterEN) || contains(item.en2?.text, this.filterEN);
        const matchFR = !this.filterFR || contains(item.fr?.text, this.filterFR) || contains(item.fr2?.text, this.filterFR);
        const matchIT = !this.filterIT || contains(item.it?.text, this.filterIT) || contains(item.it2?.text, this.filterIT);
        return matchDE && matchEN && matchFR && matchIT;
      });
    },

    oeffneModal(row) {
      this.selectedItem = row ? Object.assign({}, row) : null;
      this.$bvModal.show("relationstyp-modal");
    },

    oeffneLoeschenModal() {
      if (this.selectedIds.length > 0) {
        this.$bus.$emit("openLoeschenModal", "relationstyp-loeschen-modal");
      } else {
        this.$notify({
          type: "warn",
          title: this.$t("global.actionfailed"),
          text: this.$t("global.norecordselected"),
        });
      }
    },

    loeschen() {
      this.isBusy = true;
      AppApi.delete("auswahlwerte/relationstyp", {
        params: { ids: this.selectedIds.join(",") },
      })
        .then(() => {
          this.selectedIds = [];
          this.getData();
          this.$notify({ type: "success", title: this.$t("global.actionsuccessful") });
        })
        .catch((e) => {
          this.isBusy = false;
          this.$notify(apiErrorToAlert(e));
        });
    },

    selectAllRows(row) {
      if (row.selected) {
        this.$refs.selectableTable.items.forEach((item) => { item.selected = true; });
        this.selectedIds = this.$refs.selectableTable.items.map((item) => item.id);
      } else {
        this.$refs.selectableTable.items.forEach((item) => { item.selected = false; });
        this.selectedIds = [];
      }
    },

    onRowSelected() {
      this.selectedIds = this.$refs.selectableTable.items
        .filter((item) => item.selected)
        .map((item) => item.id);
    },
  },
};
</script>
